import { useState } from "react";
import { Link, useNavigate } from "react-router";
import { ComunicacionAjax } from "../../ts/api/comunicacion";
import { useAuth } from "../../hooks/useAuth";
import { useQueryClient } from "@tanstack/react-query";

export function LoginForm() {
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const { setAuth } = useAuth();
	const [error, setError] = useState<string | null>(null);

	const onSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		const form = e.target as HTMLFormElement;
		const email = (form.elements.namedItem("email") as HTMLInputElement).value;
		const password = (form.elements.namedItem("password") as HTMLInputElement).value;
		const plataforma = (form.elements.namedItem("plataforma") as HTMLInputElement).value;

		try {
			const res = await login(email, password, plataforma);
			if (res.status === "error") {
				setError(res.message ?? "Error desconocido al autenticar");
				return;
			}
			if (res.status === "NOK") {
				setError(res.message ?? "Error desconocido al autenticar");
				return;
			}

			setAuth(res.token);
			void queryClient.invalidateQueries();// Invalidate all queries to refresh data after login
			await navigate(res.goTo);
		} catch (error) {
			setError("Error en el login");
			console.error(error);
		}
	};

	return (
		<form role="form" className="login-form" onSubmit={onSubmit}>
			{error ? (
				<div id="contenedorErrores">
					<div className="error">{error}</div>
				</div>
			) : null}

			<input type="hidden" name="plataforma" value="web" />
			<div className="form-group">
				<input type="email" className="form-control" name="email" placeholder="Email" />
			</div>
			<div className="form-group">
				<input type="password" className="form-control" name="password" placeholder="Password" />
			</div>

			<button type="submit" className="btnPrimary" style={{ width: "100%", marginBottom: 10 }}>Login</button>

			<Link to="/recuperarcontrasena">¿Olvidaste la contraseña? Haz click aquí</Link>
		</form>
	);
}
function login(email: string, password: string, plataforma: string) {
	return ComunicacionAjax.sendAjaxRequest<LoginResponse>("POST", "/api/v1/public/login", { username: email, password: password, plataforma });
}


type LoginResponse = {
	status: "error";
	message?: string;
} | {
	status: "NOK";
	message?: string;
} | {
	status: "OK",
	roleName: "Administrador",
	goTo: string,
	token: string,
};